import {FILTER_NAMES as COMMON_FILTER_NAMES, ORDER} from '../base.js'
import {LISTING_SECTION_IDS} from '../common/listingSections.js'
import {PRICE_INDICATOR_VALUE_RANK} from './priceIndicator.js'
import {SEARCH, SORT} from './queryParams.js'

// Filter names
export const FILTER_NAMES = COMMON_FILTER_NAMES

// Default primitive values
export const DEFAULT_ARRAY_SEARCH_VALUE = []
export const DEFAULT_BOOLEAN_SEARCH_VALUE = null
export const DEFAULT_FALSE_BOOLEAN_SEARCH_VALUE = false
export const DEFAULT_FILTER_SEARCH_VALUE = null
export const DEFAULT_OPTION_SEARCH_VALUE = 0
export const DEFAULT_RANGE_SEARCH_VALUE = {from: DEFAULT_FILTER_SEARCH_VALUE, to: DEFAULT_FILTER_SEARCH_VALUE}

// Query params
export const FILTER_QUERY_PARAMS = SEARCH
export const SORT_QUERY_PARAMS = SORT

// Categories
export const AUTOCARAVANS_AND_TRAILERS_CATEGORY1_ID = 3820
export const CARS_WITHOUT_LICENSE_CATEGORY1_ID = 4000
export const CLASSIC_AND_COMPETITION_CATEGORY1_ID = 3110
export const COCHES_CATEGORY1_ID = 2500
export const VANS_AND_COMMERCIAL_CATEGORY1_ID = 2900

export const DEFAULT_CATEGORY1_ID = COCHES_CATEGORY1_ID
export const DEFAULT_CATEGORY1_IDS = [COCHES_CATEGORY1_ID]

export const DEFAULT_CATEGORY2_ID = DEFAULT_FILTER_SEARCH_VALUE
export const DEFAULT_CATEGORY2_IDS = DEFAULT_ARRAY_SEARCH_VALUE

// Categories with electric features
export const CATEGORIES_WITH_ELECTRIC_FEATURES = [COCHES_CATEGORY1_ID, VANS_AND_COMMERCIAL_CATEGORY1_ID]

// Categories whose listing hides the create alert button
export const CATEGORY_IDS_WITHOUT_ALERT_BUTTON = [VANS_AND_COMMERCIAL_CATEGORY1_ID]

// OfferTypes
export const OFFER_TYPE_SECOND_HAND = 0
export const OFFER_TYPE_NEW = 1
export const OFFER_TYPE_KM0 = 2
export const OFFER_TYPE_SUBSTITUTION = 3
export const OFFER_TYPE_MANAGEMENT = 4
export const OFFER_TYPE_DEMONSTRATION = 5
export const OFFER_TYPE_RENTAL = 7
export const OFFER_TYPE_PRE_OWNED = 8
export const OFFER_TYPE_SUBSCRIPTION = 10
export const UNSELECTED_OFFER_TYPE = -1

export const SECOND_HAND_OFFER_TYPES = [
  OFFER_TYPE_SECOND_HAND,
  OFFER_TYPE_KM0,
  OFFER_TYPE_SUBSTITUTION,
  OFFER_TYPE_MANAGEMENT,
  OFFER_TYPE_DEMONSTRATION
]

export const KM0_OFFER_TYPES = [
  OFFER_TYPE_KM0,
  OFFER_TYPE_NEW,
  OFFER_TYPE_SUBSTITUTION,
  OFFER_TYPE_MANAGEMENT,
  OFFER_TYPE_DEMONSTRATION
]

export const NEW_OFFER_TYPES = [
  OFFER_TYPE_NEW,
  OFFER_TYPE_KM0,
  OFFER_TYPE_SUBSTITUTION,
  OFFER_TYPE_MANAGEMENT,
  OFFER_TYPE_DEMONSTRATION
]

export const ALL_OFFER_TYPES = [...SECOND_HAND_OFFER_TYPES, OFFER_TYPE_NEW]

export const DEFAULT_OFFER_TYPES_IDS_BY_LISTING_SECTION_ID = {
  [LISTING_SECTION_IDS.ALL_VEHICLES]: DEFAULT_ARRAY_SEARCH_VALUE
}

export const AVAILABLE_OFFER_TYPES_IDS_BY_LISTING_SECTION_ID = {
  [LISTING_SECTION_IDS.ALL_VEHICLES]: [OFFER_TYPE_SECOND_HAND, OFFER_TYPE_KM0, OFFER_TYPE_NEW]
  // Pending to add the rest of the listing sections (WiP)
}

// To remove when we have all the listing sections
export const AVAILABLE_OFFER_TYPES_IDS_BY_OFFER_TYPE_ID = {
  [OFFER_TYPE_KM0]: KM0_OFFER_TYPES,
  [OFFER_TYPE_NEW]: KM0_OFFER_TYPES
}

// Default custom default values
export const DEFAULT_CATEGORIES_SEARCH_VALUE = {
  category1Ids: DEFAULT_CATEGORY1_IDS,
  category2Ids: DEFAULT_ARRAY_SEARCH_VALUE
}

export const DEFAULT_LOCATION_SEARCH_VALUE = {
  lat: DEFAULT_FILTER_SEARCH_VALUE,
  long: DEFAULT_FILTER_SEARCH_VALUE,
  radio: DEFAULT_FILTER_SEARCH_VALUE,
  text: DEFAULT_FILTER_SEARCH_VALUE,
  provinceId: DEFAULT_FILTER_SEARCH_VALUE
}

export const DEFAULT_MODEL_SEARCH_VALUE = {id: DEFAULT_FILTER_SEARCH_VALUE, name: DEFAULT_FILTER_SEARCH_VALUE}
export const DEFAULT_OFFER_TYPE_IDS_SEARCH_VALUE = [OFFER_TYPE_SECOND_HAND]

export const DEFAULT_VEHICLE_SEARCH_VALUE = {
  make: DEFAULT_FILTER_SEARCH_VALUE,
  makeId: DEFAULT_OPTION_SEARCH_VALUE,
  model: DEFAULT_MODEL_SEARCH_VALUE.name,
  modelId: DEFAULT_MODEL_SEARCH_VALUE.id,
  version: DEFAULT_FILTER_SEARCH_VALUE
}

// Default custom request values
export const DEFAULT_PRICE_RANK_SEARCH_REQUEST_VALUE = [
  PRICE_INDICATOR_VALUE_RANK.third,
  PRICE_INDICATOR_VALUE_RANK.fourth,
  PRICE_INDICATOR_VALUE_RANK.fifth
]

// Default filter search values
export const DEFAULT_BODY_TYPE_IDS_SEARCH = DEFAULT_ARRAY_SEARCH_VALUE
export const DEFAULT_CATEGORIES_SEARCH = DEFAULT_CATEGORIES_SEARCH_VALUE
export const DEFAULT_CITY_SEARCH = DEFAULT_FILTER_SEARCH_VALUE
export const DEFAULT_CITY_ID_SEARCH = DEFAULT_OPTION_SEARCH_VALUE
export const DEFAULT_COLOR_IDS_SEARCH = DEFAULT_ARRAY_SEARCH_VALUE
export const DEFAULT_COMMITMENT_MONTHS_SEARCH = DEFAULT_ARRAY_SEARCH_VALUE
export const DEFAULT_CONTRACT_ID_SEARCH = DEFAULT_OPTION_SEARCH_VALUE
export const DEFAULT_CUBIC_CAPACITY_SEARCH = DEFAULT_RANGE_SEARCH_VALUE
export const DEFAULT_DOORS_SEARCH = DEFAULT_RANGE_SEARCH_VALUE
export const DEFAULT_DRIVEN_WHEELS_SEARCH = DEFAULT_ARRAY_SEARCH_VALUE
export const DEFAULT_ELECTRIC_AUTONOMY_SEARCH = DEFAULT_RANGE_SEARCH_VALUE
export const DEFAULT_ELECTRIC_BATTERY_CAPACITY_SEARCH = DEFAULT_RANGE_SEARCH_VALUE
export const DEFAULT_ELECTRIC_CHARGING_TIME_FAST_MODE_SEARCH = DEFAULT_RANGE_SEARCH_VALUE
export const DEFAULT_ELECTRIC_CHARGING_TIME_STANDARD_MODE_SEARCH = DEFAULT_RANGE_SEARCH_VALUE
export const DEFAULT_ENVIRONMENTAL_LABELS_SEARCH = DEFAULT_ARRAY_SEARCH_VALUE
export const DEFAULT_EQUIPMENTS_SEARCH = DEFAULT_ARRAY_SEARCH_VALUE
export const DEFAULT_EXCLUDED_VEHICLES_SEARCH = DEFAULT_ARRAY_SEARCH_VALUE
export const DEFAULT_FINANCING_ENTRY_SEARCH = DEFAULT_FILTER_SEARCH_VALUE
export const DEFAULT_FINANCING_TERMS_SEARCH = DEFAULT_FILTER_SEARCH_VALUE
export const DEFAULT_FUEL_TYPE_IDS_SEARCH = DEFAULT_ARRAY_SEARCH_VALUE
export const DEFAULT_HAS_INSTALMENT_SEARCH = DEFAULT_FALSE_BOOLEAN_SEARCH_VALUE
export const DEFAULT_HAS_ONLINE_FINANCING_SEARCH = DEFAULT_BOOLEAN_SEARCH_VALUE
export const DEFAULT_HAS_PHOTO_SEARCH = DEFAULT_BOOLEAN_SEARCH_VALUE
export const DEFAULT_HAS_RESERVATION_SEARCH = DEFAULT_BOOLEAN_SEARCH_VALUE
export const DEFAULT_HAS_STOCK_SEARCH = DEFAULT_BOOLEAN_SEARCH_VALUE
export const DEFAULT_HAS_PRICE_DROP_SEARCH = DEFAULT_BOOLEAN_SEARCH_VALUE
export const DEFAULT_HAS_WARRANTY_SEARCH = DEFAULT_BOOLEAN_SEARCH_VALUE
export const DEFAULT_HP_SEARCH = DEFAULT_RANGE_SEARCH_VALUE
export const DEFAULT_INSTALMENT_SEARCH = DEFAULT_RANGE_SEARCH_VALUE
export const DEFAULT_IS_CERTIFIED_SEARCH = DEFAULT_FALSE_BOOLEAN_SEARCH_VALUE
export const DEFAULT_KM_SEARCH = DEFAULT_RANGE_SEARCH_VALUE
export const DEFAULT_LOCATION_SEARCH = DEFAULT_LOCATION_SEARCH_VALUE
export const DEFAULT_LUGGAGE_CAPACITY_SEARCH = DEFAULT_RANGE_SEARCH_VALUE
export const DEFAULT_OFFER_TYPE_IDS_SEARCH = DEFAULT_OFFER_TYPE_IDS_SEARCH_VALUE
export const DEFAULT_ONLY_PENINSULA_SEARCH = DEFAULT_FALSE_BOOLEAN_SEARCH_VALUE
export const DEFAULT_PRICE_SEARCH = DEFAULT_RANGE_SEARCH_VALUE
export const DEFAULT_PRICE_RANK_SEARCH = DEFAULT_ARRAY_SEARCH_VALUE
export const DEFAULT_PROVINCE_IDS_SEARCH = DEFAULT_ARRAY_SEARCH_VALUE
export const DEFAULT_RATING_SEARCH = DEFAULT_RANGE_SEARCH_VALUE
export const DEFAULT_REGION_SEARCH = DEFAULT_FILTER_SEARCH_VALUE
export const DEFAULT_REGION_ID = DEFAULT_OPTION_SEARCH_VALUE
export const DEFAULT_SEARCH_TEXT_SEARCH = DEFAULT_FILTER_SEARCH_VALUE
export const DEFAULT_SEATS_SEARCH = DEFAULT_RANGE_SEARCH_VALUE
export const DEFAULT_SELLER_TYPE_ID_SEARCH = DEFAULT_OPTION_SEARCH_VALUE
export const DEFAULT_SUBSCRIPTION_COMMITMENT_SEARCH = DEFAULT_ARRAY_SEARCH_VALUE
export const DEFAULT_SUBSCRIPTION_FEE_SEARCH = DEFAULT_RANGE_SEARCH_VALUE
export const DEFAULT_TRANSMISSION_TYPE_ID_SEARCH = DEFAULT_OPTION_SEARCH_VALUE
export const DEFAULT_VEHICLE_SEARCH = DEFAULT_VEHICLE_SEARCH_VALUE
export const DEFAULT_VEHICLES_SEARCH = DEFAULT_ARRAY_SEARCH_VALUE
export const DEFAULT_YEAR_SEARCH = DEFAULT_RANGE_SEARCH_VALUE

export const DEFAULT_FILTERS_SEARCH = {
  [COMMON_FILTER_NAMES.BODY_TYPE]: DEFAULT_BODY_TYPE_IDS_SEARCH,
  [COMMON_FILTER_NAMES.CATEGORY_1]: DEFAULT_CATEGORIES_SEARCH.category1Ids,
  [COMMON_FILTER_NAMES.CATEGORY_2]: DEFAULT_CATEGORIES_SEARCH.category2Ids,
  [COMMON_FILTER_NAMES.COLOR]: DEFAULT_COLOR_IDS_SEARCH,
  [COMMON_FILTER_NAMES.DOOR]: DEFAULT_DOORS_SEARCH,
  [COMMON_FILTER_NAMES.DRIVEN_WHEELS]: DEFAULT_DRIVEN_WHEELS_SEARCH,
  [COMMON_FILTER_NAMES.ELECTRIC_AUTONOMY]: DEFAULT_ELECTRIC_AUTONOMY_SEARCH,
  [COMMON_FILTER_NAMES.ELECTRIC_BATTERY_CAPACITY]: DEFAULT_ELECTRIC_BATTERY_CAPACITY_SEARCH,
  [COMMON_FILTER_NAMES.ELECTRIC_CHARGING_TIME_FAST_MODE]: DEFAULT_ELECTRIC_CHARGING_TIME_FAST_MODE_SEARCH,
  [COMMON_FILTER_NAMES.ELECTRIC_CHARGING_TIME_STANDARD_MODE]: DEFAULT_ELECTRIC_CHARGING_TIME_STANDARD_MODE_SEARCH,
  [COMMON_FILTER_NAMES.ENVIRONMENTAL_LABEL]: DEFAULT_ENVIRONMENTAL_LABELS_SEARCH,
  [COMMON_FILTER_NAMES.EQUIPMENTS]: DEFAULT_EQUIPMENTS_SEARCH,
  [COMMON_FILTER_NAMES.EXCLUDED_VEHICLES]: DEFAULT_EXCLUDED_VEHICLES_SEARCH,
  [COMMON_FILTER_NAMES.FINANCING_ENTRY]: DEFAULT_FINANCING_ENTRY_SEARCH,
  [COMMON_FILTER_NAMES.FINANCING_TERMS]: DEFAULT_FINANCING_TERMS_SEARCH,
  [COMMON_FILTER_NAMES.FUEL_TYPE]: DEFAULT_FUEL_TYPE_IDS_SEARCH,
  [COMMON_FILTER_NAMES.HAS_INSTALMENT]: DEFAULT_HAS_INSTALMENT_SEARCH,
  [COMMON_FILTER_NAMES.HAS_ONLINE_FINANCING]: DEFAULT_HAS_ONLINE_FINANCING_SEARCH,
  [COMMON_FILTER_NAMES.HAS_PHOTO]: DEFAULT_HAS_PHOTO_SEARCH,
  [COMMON_FILTER_NAMES.HAS_PRICE_DROP]: DEFAULT_HAS_PRICE_DROP_SEARCH,
  [COMMON_FILTER_NAMES.HAS_RESERVATION]: DEFAULT_HAS_RESERVATION_SEARCH,
  [COMMON_FILTER_NAMES.HAS_STOCK]: DEFAULT_HAS_STOCK_SEARCH,
  [COMMON_FILTER_NAMES.HAS_WARRANTY]: DEFAULT_HAS_WARRANTY_SEARCH,
  [COMMON_FILTER_NAMES.HP]: DEFAULT_HP_SEARCH,
  [COMMON_FILTER_NAMES.INSTALMENT]: DEFAULT_INSTALMENT_SEARCH,
  [COMMON_FILTER_NAMES.IS_CERTIFIED]: DEFAULT_IS_CERTIFIED_SEARCH,
  [COMMON_FILTER_NAMES.KMS]: DEFAULT_KM_SEARCH,
  [COMMON_FILTER_NAMES.LITRES]: DEFAULT_CUBIC_CAPACITY_SEARCH,
  [COMMON_FILTER_NAMES.LOCATION]: DEFAULT_LOCATION_SEARCH,
  [COMMON_FILTER_NAMES.LUGGAGE_CAPACITY]: DEFAULT_LUGGAGE_CAPACITY_SEARCH,
  [COMMON_FILTER_NAMES.OFFER_TYPE]: DEFAULT_OFFER_TYPE_IDS_SEARCH,
  [COMMON_FILTER_NAMES.ONLY_PENINSULA]: DEFAULT_ONLY_PENINSULA_SEARCH,
  [COMMON_FILTER_NAMES.PRICE]: DEFAULT_PRICE_SEARCH,
  [COMMON_FILTER_NAMES.PRICE_RANK]: DEFAULT_PRICE_RANK_SEARCH,
  [COMMON_FILTER_NAMES.PROVINCE]: DEFAULT_PROVINCE_IDS_SEARCH,
  [COMMON_FILTER_NAMES.RATING]: DEFAULT_RATING_SEARCH,
  [COMMON_FILTER_NAMES.SEARCH_TEXT]: DEFAULT_SEARCH_TEXT_SEARCH,
  [COMMON_FILTER_NAMES.SEAT]: DEFAULT_SEATS_SEARCH,
  [COMMON_FILTER_NAMES.SELLER_TYPE]: DEFAULT_SELLER_TYPE_ID_SEARCH,
  [COMMON_FILTER_NAMES.TRANSMISSION_TYPE]: DEFAULT_TRANSMISSION_TYPE_ID_SEARCH,
  [COMMON_FILTER_NAMES.VEHICLES]: DEFAULT_VEHICLES_SEARCH,
  [COMMON_FILTER_NAMES.YEAR]: DEFAULT_YEAR_SEARCH
}

export const SORT_ORDER_VALUES = {
  [ORDER.ASC]: 1,
  [ORDER.DESC]: -1
}

export const DEFAULT_MIN_INSTALMENT_PRICE = 1
